// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__gsfHQ","centerContent":"MainLayout_centerContent__8ZWZu"};